import { Brain, Handshake, Network, ShieldCheck } from 'lucide-react';
import './hero-experience.css';

// Owner copy (2026-10-15). Every claim is backed in code: brief, follow-up held for
// review and CRM push; replay validation with narration fallback; mid-call language switch.
// Moved out of Hero.tsx 2026-10-22 (owner: two bands stacked under the hero read as one
// heavy block) — this now sits immediately after "One brain". Markup, copy, icons, order
// and the .fx-rail/.fx-rail-card classes are unchanged; only the wrapper is a <section>
// (so it takes part in the page's section rhythm where it now lives) and the hero's
// load-in stagger (fx-ld fx-d5, animation-delay .4s) is replaced by the in-page scroll
// reveal (fx-rv) its new neighbours use — a hero entrance delay is meaningless below the
// fold. It carries no choreography beat: CHOREOGRAPHY.md's only "rail" is Mr. Clippy's
// sticky gutter rail, which is a different thing and is untouched.
const statements = [
  [Handshake, 'Sells, not just shows.', 'Qualifies, demos, follows up.'],
  [Brain, 'Knows your product cold.', 'Every screen, every flow, every answer.'],
  [ShieldCheck, 'Verified. Multi-lingual. Live.', 'Real product, real browser, in the buyer’s language.'],
  [Network, 'Your whole stack hears it.', 'Sales, Product, CRM, Slack. One brief, everywhere.'],
] as const;

export function StatementRail() {
  return (
    <section className="fx-rail fx-rv" aria-label="Four things that are true">
      <div className="container">
        {statements.map(([Icon, lead, rest]) => (
          <div className="fx-rail-card" key={lead}>
            <Icon size={24} aria-hidden="true" />
            <b>{lead}</b>
            <span>{rest}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
